import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import styled from '@nobia/zeus-components/lib/styled'
import { Container, Row, Column } from '@nobia/zeus-components/lib/grid'

import DigitInput from '../digit-input/DigitInput'
import ProductData from '../product-data/ProductData'

const Label = styled.div`
  font-size: 20px;
`

class ProductCodeInput extends Component {
  state = {
    disabled: false,
    error: false,
    productToFetch: '',
  }

  productCode = [null, null, null, null]

  requestProduct = pcode => {
    // console.log('in product code input, requesting product..')
    this.setState({ disabled: true })
    this.setState({ productToFetch: pcode }) // request it from the ProductData component
  }

  receiveProduct = product => {
    // console.log('received product: ', product)
    if (product) {
      this.setState({ error: false })
      setTimeout(() => {
        this.props.onProductFetch(product)
      }, 1000)
    } else {
      // console.log('null product received')
      // this.setState({error: true})
    }
  }

  handleError = () => {
    // console.log('in handle error')
    this.setState({ error: true })
  }

  handleInput = (digit, digitInputIndex) => {
    const digitInputs = [this.di0, this.di1, this.di2, this.di3]
    if (digit >= 0 && digit <= 9 && digitInputIndex <= 3) {
      // focus on next:
      this.productCode[digitInputIndex] = digit
      if (digitInputIndex < 3) {
        ReactDOM.findDOMNode(digitInputs[digitInputIndex + 1]).focus() // eslint-disable-line react/no-find-dom-node
      }
    } else if (digit === 'DEL' && digitInputIndex >= 0) {
      // focus on previous
      this.productCode[digitInputIndex] = null
      if (digitInputIndex > 0) {
        ReactDOM.findDOMNode(digitInputs[digitInputIndex - 1]).focus() // eslint-disable-line react/no-find-dom-node
      }
    }
    const pcode = this.productCode.join('')
    if (pcode.length === 4) {
      this.requestProduct(pcode)
    }
  }

  render() {
    return (
      <Container>
        <Row>
          <Column>
            <DigitInput
              autoFocus
              onDigitInput={this.handleInput}
              digitInputIndex={0}
              digitInputRef={el => {
                this.di0 = el
              }}
              disabled={this.state.disabled}
              error={this.state.error}
            />
            <DigitInput
              onDigitInput={this.handleInput}
              digitInputIndex={1}
              digitInputRef={el => {
                this.di1 = el
              }}
              disabled={this.state.disabled}
              error={this.state.error}
            />
            <DigitInput
              onDigitInput={this.handleInput}
              digitInputIndex={2}
              digitInputRef={el => {
                this.di2 = el
              }}
              disabled={this.state.disabled}
              error={this.state.error}
            />
            <DigitInput
              onDigitInput={this.handleInput}
              digitInputIndex={3}
              digitInputRef={el => {
                this.di3 = el
              }}
              disabled={this.state.disabled}
              error={this.state.error}
            />
          </Column>
        </Row>
        <Row>
          <Column xs={12}>
            <Label>Product code</Label>
          </Column>
        </Row>
        <Row>
          <Column xs={12}>
            <ProductData
              productToFetch={this.state.productToFetch}
              onProductFetch={this.receiveProduct}
              onError={this.handleError}
              error={this.state.error}
            />
          </Column>
        </Row>
      </Container>
    )
  }
}

ProductCodeInput.propTypes = {
  onProductFetch: PropTypes.func.isRequired,
}

export default ProductCodeInput
